import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import ProductSelectionPage from '../../../components/ProductSelectionPage/motorplay/products';
import { selectCurrentContentFichaPath } from '../../../queries/selectors/contents';
import { selectUserData } from '../../../queries/selectors/user';

import withNoMembershipPurchased from '../../withNoMembershipPurchased';
import { selectAddOnsEnabled, selectClient, selectProductToUpgrade, selectSearchObj } from '../../../global-selectors';
import { selectAllSubPaymentMethodsConfig, selectCurrentPaymentMethod, selectPaymentMethods } from '../../../queries/selectors/payment';
import withAuthGuard from '../../withAuthGuard';
import { addProduct, cleanOrder } from '../../../queries/actions/shoppingCart';
import { selectProductTypePlan, selectSingleSubscriptionClient } from '../../../queries/selectors/bootstrap';
import { hiddenCouponInput, resetProductExchange, updateInitialExchangeByDeviceCountry } from '../../../queries/actions';
import { selectActiveAddOnSubscriptions, selectProducts } from '../../../queries/selectors/products';
import { applyProductRules } from '../../../queries/actions/rules';
import { injectIntl } from 'react-intl';
import { setCurrentSubPaymentMethod } from '../../../queries/actions/payment';
import { connectRequest } from '../../../utils/query';
import { getSubPaymentMethodsByClient } from '../../../queries/paymentMethods';
import withNoAvailableProducts from '../../withNoAvailableProducts';
import { filterHiddenProducts } from '../../../utils/products';
import { selectShoppingCartConfig } from '../../../queries/selectors/shoppingCart';

const mapStateToProps = state => {
  const userData = selectUserData(state);
  const products = selectProducts(state);
  const queryParamsObject = selectSearchObj(state);
  return {
    path: selectCurrentContentFichaPath(state),
    user: userData,
    productToUpgradeId: selectProductToUpgrade(state),
    paymentMethod: selectCurrentPaymentMethod(state),
    products: filterHiddenProducts(queryParamsObject, products),
    plans: selectProductTypePlan(state),
    isSingleSubscriptionClient: selectSingleSubscriptionClient(state),
    client: selectClient(state),
    methods: selectPaymentMethods(state),
    subPaymentMethods: selectAllSubPaymentMethodsConfig(state),
    token: userData?.token,
    userAddOnsPurchased: selectActiveAddOnSubscriptions(state),
    queryParamsObject,
    isAddOnsEnabled: selectAddOnsEnabled(state),
    shoppingCart: selectShoppingCartConfig(state)
  }
}

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    cleanOrder: payload => dispatch(cleanOrder(payload)),
    setCurrentSubPaymentMethod: payload => dispatch(setCurrentSubPaymentMethod(payload)),
    addProduct: payload => dispatch(addProduct(payload)),
    resetProductExchange: () => resetProductExchange(),
    hiddenCouponInput: (data) => hiddenCouponInput(data),
    applyProductRules: (data) => dispatch(applyProductRules(data)),
    updateInitialExchangeByDeviceCountry: payload => updateInitialExchangeByDeviceCountry(payload),
  }, dispatch)
);

const mapPropsToConfig = (props) => [
  getSubPaymentMethodsByClient(props)
];

export default compose(
  withAuthGuard({ toLoginURL: true }),
  withNoMembershipPurchased,
  withNoAvailableProducts('plan'),
  connect(mapStateToProps, mapDispatchToProps),
  connectRequest(mapPropsToConfig),
  injectIntl
)(ProductSelectionPage);
